import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-16825 Lead Finder — a location this tenant dismissed as "not a fit".
 *
 * A dismissed location leaves every Lead Finder tab except Dismissed, where
 * it can be restored. Restoring soft-removes the row; dismissing it again
 * recovers the same row (the location key is unique), so `_creator_userId` /
 * `_modified_userId` and the audit trail say who dismissed and restored it.
 *
 * `locationKey` is workd_mission_control.lm_lead_location.location_key. The
 * list compares it across databases with an explicit utf8mb4_0900_ai_ci
 * collation (lead-finder-sql.ts DISMISSED_SQL), the one pinned on this column.
 * Additive only: the database sync creates the table; no other table changes.
 */
@Index('uq_lead_finder_dismissal_location', ['locationKey'], { unique: true })
@Entity('lead_finder_dismissal')
export class LeadFinderDismissalEntity extends BaseEntity {
	// Charset and collation pinned to mission control's, so the cross-database
	// comparison never depends on the tenant schema's default (latin1 on some).
	@Column({ type: 'varchar', name: 'locationKey', length: 191, charset: 'utf8mb4', collation: 'utf8mb4_0900_ai_ci' })
	public locationKey!: string;

	@Column('varchar', { name: 'reason', length: 255, nullable: true })
	public reason!: string | null;
}
